import { createAction } from "../../../helpers";
import * as constants from "./contants";

export const actLogout = () => {
  return (dispatch) => {
    localStorage.removeItem("User");
    dispatch(createAction(constants.USER_CLEAR_DATA));
  };
};
